import React from "react";

export type ViewType = "posts" | "reported";

interface ViewSwitcherProps {
  activeView: ViewType;
  onViewChange: (view: ViewType) => void;
}

const ViewSwitcher: React.FC<ViewSwitcherProps> = ({
  activeView,
  onViewChange,
}) => {
  return (
    <div className="inline-flex rounded-lg bg-gray-100 p-1 dark:bg-navy-800">
      <button
        onClick={() => onViewChange("posts")}
        className={`rounded-md px-4 py-2 text-sm font-medium transition-all ${
          activeView === "posts"
            ? "bg-biafit-primary text-white shadow-sm"
            : "text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200"
        }`}
      >
        Community Posts
      </button>
      <button
        onClick={() => onViewChange("reported")}
        className={`rounded-md px-4 py-2 text-sm font-medium transition-all ${
          activeView === "reported"
            ? "bg-biafit-primary text-white shadow-sm"
            : "text-gray-700 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200"
        }`}
      >
        Reported Posts
      </button>
    </div>
  );
};

export default ViewSwitcher;
